import React, { Component } from 'react';

export default class Information extends Component {
  render() {
    return (
      <div>
        <h1>Intern information</h1>
        <p>Information för en inloggad medlem.</p>
      </div>
    );
  }
}
